import * as ActionTypes from './actionTypes.js';
var _ = require('lodash');
const inititalState = {
  notification_list: [],
  template: 'NOTIFICATIONS',
  title: 'Notifications',
  visible: false,
  placement: 'right',
  customHeader: null,
};

export default function appSidebarReducer(state = inititalState, action) {
  switch (action.type) {
    case ActionTypes.SHOW_SIDEBAR:
      return _.extend({}, state, {
        visible: true,
        template: action.payload.template,
        templateData: action.payload.templateData,
        title: action.payload.title,
        placement: action.payload.placement,
        customHeader: action.payload.customHeader
      });
    case ActionTypes.HIDE_SIDEBAR:
      return _.extend({}, state, { visible: false });
    case ActionTypes.HIDE_SIDEBAR_AND_CLEAR_DATA:
      return _.extend({}, state, { visible: false, templateData: [] });
    case ActionTypes.FETCH_NOTIFICATIONS:
    case ActionTypes.RESET_NOTIFICATIONS:
    case ActionTypes.FETCH_NOTIFICATIONS_FAILED:
    case ActionTypes.FETCH_NOTIFICATIONS_SUCCESS:
      return _.extend({}, state, action.payload);
    default:
      return state;
  }
}
